module.exports = __webpack_public_path__ + "img/4-2-south-3.3aa20ffd.jpg";